module.exports = __webpack_public_path__ + "static/img/touxiangkaobei5.358ea78.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/touxiangkaobei5.png
// module id = Y0ZG
// module chunks = 1